var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCobrancaPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 230 218",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#E0E0E0",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212 63h-22v23h22V63ZM230 21h-32v33h32V21ZM12 197l1 15h20l2-15H12ZM37 190H10v7h27v-7ZM227 217Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M163 22h-13a3 3 0 0 0-3 4v2a3 3 0 0 1-4 3h-25a3 3 0 0 1-3-3v-2a3 3 0 0 0-4-4H95a10 10 0 0 0-10 11l-1 166a10 10 0 0 0 10 10l68 1a10 10 0 0 0 11-11V33a10 10 0 0 0-10-11Zm-8 152h-53c-4 0-8 4-8 9v1c0 5 4 8 8 8h53c4 0 8-3 8-8v-1c0-5-4-9-8-9ZM95 62h68l2 2v41l-2 2H95l-2-2V64l2-2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 21 2 4 1-1-1-4h-1l-1 1ZM17 19v1l1 3 2-1-1-3-2-1v1ZM19 18l1 4s2 0 1-1l-1-3-1-1v1ZM20 17l2 4 1-1-1-4h-1l-1 1ZM44 43a9 9 0 0 1 10 2l4 4c2 2 4 2 7 2 2 0 5 0 6 2l1 3 2 3 2 1 3 1-5 8h-2v2l-4 3-3-4-3-3-4-1-4-1-1-3a4 4 0 0 0-4-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 60 1 2 3 1h3l4 4a5 5 0 0 0 7-3 5 5 0 0 1-5 0c-2-1-2-3-4-3h-4l-4-2h-1v1ZM82 156l19-7-3-9-20 5 4 11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98 150 1-1s7 9 8 8l-5-18-6 2a11 11 0 0 1 2 9ZM39 192l5 20 9-2-3-21-11 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43 209 1 1-9 7 19-4-2-6a11 11 0 0 1-9 2ZM29 110s-1 37 3 62l8 27 11-2-5-40v-53l-17 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36 107 11 42a16 16 0 0 0 19 11h1l25-7-4-11-23 4-3-24s-4-19-10-19l-16 4ZM24 27v3l-1 20c0 3 9 18 9 18l-6 9-12-22-1-3 3-24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23 50 9 13 8 5c7 0 15-1 19 5a4 4 0 0 1 0 3l-7 23s3 2 2 4h-2l-23 7-1-1 2-5V93l-1-4v-8c-3-5-10-13-14-23l8-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 52a8 8 0 0 0-7-9c-5 0-8 3-9 7l-1 9c0 4 2 5 3 6a5 5 0 0 0 1 0v5c-1 3 1 5 4 6 3 0 5-2 6-5l3-19ZM56 76l2 1-1 30-2-3 1-28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53 75-9 26 11 3 1-28-1 1-2-2ZM67 105l-10 2V76l1 1 9 28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67 105-10 2V76l1 1 9 28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77 99-10 5-10-26 3-2 17 23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79 97-2 2-17-23 2-1 17 22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79 97-2 2-17-23 2-1 17 22ZM40 43c-2 1-5 3-4 7l8-5c0 3 0 4 2 6l5 5v-3s-2-12-11-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48 52 1 5c1 2 3 3 5 2l-2-1a3 3 0 0 0 4 0 12 12 0 0 1-8-6M26 16l-12 6v1l2 5 2 1 12-7v-1l-2-5h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 21-1-1h-1l-1-2h1v-1l-1-1a1 1 0 0 0-1 0l-11 6a1 1 0 0 0-1 1l3 5a1 1 0 0 0 1 0l11-6a1 1 0 0 0 1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 30 2-2 2-3v-1l-6-1s-1 2 1 2c-2 1-3 3-3 5h4ZM196 175a19 19 0 0 0-6-18s-2-1-1 1c0 1-1 3-2 2l-2-5c0-2-2-3-4-4-4-1-7-3-11-3-4-1-7-1-11 1l3 5a2 2 0 0 0 2 1h6l-1 2-5 1c1 3 4 4 6 6l8 2h2l4-2a6 6 0 0 1-2 4l14 7M210 138c-1 1-5 1-5-2 0-2 3-3 4-2 1-6 0-12-1-18l-2 3c-1 1-2 2-4 1-1 0-2-3-1-4l3-4a17 17 0 0 0-10-9l-5 10c-1 3 0 7 2 9l3 4c1 1 1 3-1 3-1 1-3 0-4-2l-3-3c-1 11 5 24 15 30 4-5 7-10 9-16Zm-8-13 3-2a1 1 0 0 1 2 0 2 2 0 0 1 0 2l-1 1-2 1a3 3 0 0 1-2 0 2 2 0 0 1-1-1 2 2 0 0 1 1-1ZM184 189l5 20h25l5-20h-35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192 205 2 12h15l2-12h-19ZM47 9l-2 15h15L57 9H47Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h230v218H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCobrancaPlaceholder);
export default __webpack_public_path__ + "static/media/cobrancaPlaceholder.907e24e449e8777db03e18d881ec64e2.svg";
export { ForwardRef as ReactComponent };